import type { ChangelogEntry } from "../types";

/** Leadlistene får egen fane og tilgang, og leads kan legges inn for hånd. */
export const LEADLISTER_NYTT_LEAD_2026_10: ChangelogEntry = {
  id: "2026-10-28-leadlister-og-nytt-lead",
  date: "2026-10-28",
  title: "Leadlistene har fått egen fane, og du kan legge inn et lead for hånd",
  summary: "Leads viser nå bare det du trenger for å ringe. Listene og ringeaktiviteten ligger i den nye fanen Leadlister, og «Nytt lead» legger inn ett selskap fra Brønnøysund.",
  sections: [
    {
      heading: "Salgsmuligheter",
      minRole: "user",
      items: [
        {
          title: "Leads er bare ringing",
          kind: "forbedret",
          featureFlag: "feature_crm_leads_moter",
          body: "Leads henter neste lead med en gang du åpner fanen. Knappen «Begynn å ringe» er borte, og listene og ringeaktiviteten står ikke lenger under kortet.",
        },
        {
          title: "Ny fane: Leadlister",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Ringeaktiviteten og leadlistene har fått en egen fane med egen tilgang i Tilganger og roller (menypunktet Leadlister). Utbyttet per liste står nå som en kolonne i listetabellen.",
        },
        {
          title: "Nytt lead",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Legg inn ett selskap for hånd: søk på navn eller org.nr. i Brønnøysund, legg til en kontaktperson om du har en, og velg om du ringer selv eller legger det til alle. Finnes selskapet som kunde eller lead fra før, sier dialogen fra.",
        },
      ],
    },
  ],
};
